import { getDomain } from '@/utils/getDomain';
import { getUrl } from '@/utils/getUrl';
import { isClient } from '@/utils/isClient';

export const getAipAccountUrl = () => {
  return process.env.AIP_ACCOUNT_URL;
};

export const getUserAuthUrl = () => {
  return isClient() ? window.location.origin : getDomain(false);
};

const getAuthUrl = (path = '', params?: Record<string, string>) => {
  const url = getUrl(path, getUserAuthUrl());

  if (!url) {
    throw Error('Unable to get user auth url');
  }

  url.search = new URLSearchParams(params ?? { return: getDomain(false) }).toString();

  return url.href;
};

export const getUserLogInUrl = (params?: Record<string, string>) => {
  return getAuthUrl('/api/auth/login', params);
};

export const getUserSignUpUrl = (params?: Record<string, string>) => {
  return getAuthUrl('/api/auth/login', params);
};

export const getUserPageUrl = () => {
  const url = getUrl('/settings', getAipAccountUrl());
  return url?.href;
};

export const getUserLogOutUrl = (params?: Record<string, string>) => {
  return getAuthUrl('/api/auth/logout', params);
};

export const getPasswordResetPageUrl = () => {
  const url = getUrl('/recovery', getAipAccountUrl());
  return url?.href;
};
